export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  home: {
    home: "/dashboards",
  },
  countries: {
    countries: "/countries",
    createCountries: "/countries/create",
    language: "/language",
    createLanguage: "/language/create",
  },
  client: {
    client: "/client",
    logs: "/logs",
    createClient: "/client/create",
  },

  slideshow: {
    slideshow: "/slideshow",
    createslideshow: "/slideshow/create",
  },
  workWithUs: {
    workWithUs: "/work-with-us",
  },
  discoverNextlink: {
    discoverNextlink: "/discover-nextlink",
  },
  services: {
    services: "/services",
    createServices: "/services/create",
  },
  subservices: {
    SubServices: "/sub_services",
    createSubServices: "/sub_services/create",
  },
  subServicesMain: {
    subServicesMain: "/sub_services_main",
    createSubServicesMain: "/sub_services_main/create",
  },
  subServicesListing: {
    subServicesListing: "/sub_services_listing",
    createSubServicesListing: "/sub_services_listing/create",
  },

  industries: {
    industries: "/industries",
    createIndustries: "/industries/create",
  },

  industriesDetails: {
    industriesDetails: "/industries_details",
    createIndustriesDetails: "/industries_details/create",
  },

  nextLink: {
    nextLink: "/next_link",
    createNextLink: "/next_link/create",
  },
  trustedBy: {
    trustedBy: "/trusted",
    createTrustedBy: "/trusted/create",
  },

  ourClients: {
    ourClients: "/our_clients",
    createOurClients: "/our_clients/create",
  },

  news: {
    news: "/news",
    createnNews: "/news/create",
  },

  stats: {
    stats: "/stats",
    createStats: "/stats/create",
  },

  work: {
    work: "/work_diversity",
    createWork: "/work_diversity/create",
  },

  projects: {
    projects: "/csr_projects",
    createProjects: "/csr_projects/create",
  },
  values: {
    values: "/values",
    createValues: "/values/create",
  },
  awards: {
    awards: "/awards",
    createAwards: "/awards/create",
    awardsType: "/awardsType",
  },

  innovation: {
    innovation: "/innovation",
  },
  about: {
    about: "/about",
  },
  ceo: {
    ceo: "/ceo",
  },
  policies: {
    policies: "/policies",
  },
  settings: {
    settings: "/settings",
    createSettings: "/settings/update",
  },
  seo: {
    seo: "/seo",
    createSeo: "/seo/create",
  },

  admins: {
    admins: "/admins",
    addAdmins: "/admins/create",
  },
  privileges: {
    addPrivileges: "/privileges/create",
    privileges: "/privileges",
  },
};
